export const CHANGE_DEVICE_REAL_IDENTITY = 'CHANGE_DEVICE_REAL_IDENTITY'

export const CHANGE_DEVICE_IDENTITY = 'CHANGE_DEVICE_IDENTITY'
